import Vue from 'vue'
import Router from 'vue-router'
import Loading from '@/components/loading'
import Page0 from '@/components/page0'
import Page1 from '@/components/page1'
import Page2 from '@/components/page2'
import Page3 from '@/components/page3'
import Page4 from '@/components/page4'
import Page5 from '@/components/page5'
import Page6 from '@/components/page6'
import Page7 from '@/components/page7'
import Page8 from '@/components/page8'
import Page9 from '@/components/page9'
import Page10 from '@/components/page10'
import Page11 from '@/components/page11'
import Page12 from '@/components/page12'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Loading
    },
    {
      path: '/page0',

      component: Page0
    },
    {
      path: '/page1',

      component: Page1
    },
    {
      path: '/page2',

      component: Page2
    }, 
    {
      path: '/page3',

      component: Page3
    },
    {
      path: '/page4',

      component: Page4
    },
    {
      path: '/page5',

      component: Page5
    },
    {
      path: '/page6',

      component: Page6
    },
    {
      path: '/page7',

      component: Page7
    },
    {
      path: '/page8',

      component: Page8
    },
    {
      path: '/page9',

      component: Page9
    },
    {
      path: '/page10',

      component: Page10
    },
    {
      path: '/page11',

      component: Page11
    },
    {
      path: '/page12',

      component: Page12
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js